import React from "react"
import { Box, CssBaseline, useTheme } from "@mui/material"
import TrackingTile from "../../components/TrackingTile"

const ShiftTracking = () => {
    const theme = useTheme()

    return (
        <Box
            width={"100%"}
            display={"flex"}
            justifyContent={"center"}
            height={"100vh"}
            bgcolor={theme.palette.common.white}
            position={"fixed"}
        >
            <TrackingTile />
            <CssBaseline />
        </Box>
    )
}

export default ShiftTracking
